module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('div', {
    staticClass: "mw8 center pa3 white flex flex-wrap",
    staticStyle: {
      "align-items": "center"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "f2 w-100"
  }, [_vm._v("Echoppe")]), _vm._v(" "), _c('div', {
    staticClass: "ttu f5 pt3"
  }, [_vm._v("Admin")]), _vm._v(" "), _c('div', {
    staticClass: "f5 pt3 tr pointer",
    staticStyle: {
      "flex-grow": "1"
    },
    on: {
      "click": _vm.signout
    }
  }, [_vm._v("→ Sign out")])])]), _vm._v(" "), _c('tab-nav'), _vm._v(" "), _c('main', {
    staticClass: "mw8 center"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('img', {
    staticClass: "pr2",
    staticStyle: {
      "max-width": "36px"
    },
    attrs: {
      "src": "/admin/static/img/echoppe_logo_white.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c504ec9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./admin/src/App.vue
// module id = 250
// module chunks = 0